import React, { useEffect, useState } from "react";
import {
  Modal,
  Form,
  Input,
  Select,
  Button,
  Spin,
  InputNumber,
  Divider,
} from "antd";
import cancelX from "../../../Assets/svg/cancelXbutton.svg";
import "react-phone-input-2/lib/style.css";
import { httpService } from "../../../services/httpService.service";
import ProjectIcon from "../../../Assets/svg/iconMenu1.svg";
import showConfirm from "../../components/ExitConfirm/ExitConfirm";

const { Option } = Select;
const { TextArea } = Input;

const EditProject = ({ visible, onClose, projectId, onSubmit, setMessage }) => {
  const [allCountries, setAllCountries] = useState([]);
  const [loading, setLoading] = useState(false);
  const [clients, setClients] = useState([]);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [componentLoading, setComponentLoading] = useState(false);
  const [loadingCities, setLoadingCities] = useState(false);
  const [form] = Form.useForm();

  const handleCancel = () => {
    showConfirm(handleLeave, handleReturn);
  };

  const handleLeave = () => {
    form.resetFields();
    onClose();
  };

  const handleReturn = () => {
    // console.log("Cancel action");
  };

  useEffect(() => {
    if (projectId && visible) {
      setComponentLoading(true);

      getContractClients();
      httpService.get(
        `/api/Projects?id=${projectId}`,
        (res) => {
          const project = res.data;

          const countryId = project?.projectDetails?.country?.id;
          const stateIds = project?.projectDetails?.states.map(
            (state) => state.id
          );

          form.setFieldsValue({
            projectName: project?.projectName,
            projectNumber: project?.projectNumber,
            countryId: countryId,
            state: project?.projectDetails?.states.map((state) => state.id),
            cityId: project?.projectDetails?.locations?.map((city) => city.id),
            clients: project?.clients?.map((client) => client.id),
            clientFocalPoint: project?.projectDetails?.clientFocalPoint,
            clientFocalPointEmail:
              project?.projectDetails?.clientFocalPointEmail,
            projectDescription: project?.description,
            referenceDocuments: project?.projectDetails?.referenceDocuments,
            linkToSharedDrive: project?.projectDetails?.linkToSharedDrive,
            targetVisits: project?.projectDetails?.targetVisits,
            additionalVisits: project?.projectDetails?.additionalVisits,
            // F-03 — optional per-project escalation override.
            stalledThresholdDays:
              project?.stalledThresholdDays ??
              project?.projectDetails?.stalledThresholdDays ??
              undefined,
          });

          getCountries();
          getStates(countryId);
          getCities(stateIds);
          setComponentLoading(false);
        }
        // (error) => console.log(error)
      );
    }
  }, [visible, projectId]);

  const getCountries = () => {
    const contractId = localStorage.getItem("currentContractId");
    const apiCountries = `/api/GeoData/getCountriesOfContract?contractId=${contractId}`;
    httpService.get(
      apiCountries,
      (res) => setAllCountries(res.data)
      // (error) => console.log(error)
    );
  };

  const getStates = (countryId) => {
    const apiCountries = `/api/GeoData/states?countryIds=${[countryId]}`;
    httpService.get(
      apiCountries,
      (res) => setStates(res.data)
      // (error) => console.log(error)
    );
  };

  const getCities = (stateIds) => {
    httpService.post(
      `/api/GeoData/cities`,
      stateIds,
      (res) => setCities(res.data)
      // (error) => console.log(error)
    );
  };

  const getContractClients = () => {
    const contractId = localStorage.getItem("currentContractId");
    httpService.get(
      `/api/Contract/getClients?contractId=${contractId}`,
      (res) => {
        const data = res.data;
        setClients(data);
      },
      (err) => {
        // console.log(err);
      }
    );
  };

  const handleCountryChange = (countryId) => {
    form.setFieldsValue({
      state: [],
    });
    setStates([]);
    setCities([]);
    if (countryId) {
      setLoadingCities(true);
      httpService.get(
        `/api/GeoData/states?countryIds=${countryId}`,
        (res) => {
          setStates(res.data);
          setLoadingCities(false);
        },
        (error) => {
          setLoadingCities(false);
        }
      );
    }
  };

  const handleStateChange = (selectedValues) => {
    // If 'Select All' is selected
    if (selectedValues.includes("__all__")) {
      const allStateIds = states.map((state) => state.id);
      form.setFieldsValue({
        state: allStateIds,
        cityId: undefined,
      });
      setCities([]);
      if (allStateIds.length > 0) {
        setLoadingCities(true);
        httpService.post(
          `/api/GeoData/cities`,
          allStateIds,
          (res) => {
            setCities(res.data);
            setLoadingCities(false);
          },
          (error) => {
            setLoadingCities(false);
          }
        );
      }
    } else {
      form.setFieldsValue({
        state: selectedValues,
        cityId: undefined,
      });
      setCities([]);
      if (selectedValues.length > 0) {
        setLoadingCities(true);
        httpService.post(
          `/api/GeoData/cities`,
          selectedValues,
          (res) => {
            setCities(res.data);
            setLoadingCities(false);
          },
          (error) => {
            setLoadingCities(false);
          }
        );
      }
    }
  };

  const handleCityChange = (selectedValues) => {
    if (selectedValues.includes("__all__")) {
      const allCityIds = cities.map((city) => city.id);
      form.setFieldsValue({
        cityId: allCityIds,
      });
    } else {
      form.setFieldsValue({
        cityId: selectedValues,
      });
    }
  };

  const handleOk = () => {
    form
      .validateFields()
      .then((values) => {
        setLoading(true);
        const requestBody = {
          id: projectId,
          projectName: values.projectName,
          projectNumber: values.projectNumber,
          description: values.projectDescription || "",
          // F-03 — optional per-project escalation override. Empty means fall
          // back to the per-task-type threshold (or the platform default).
          stalledThresholdDays: values.stalledThresholdDays ?? null,
          projectDetails: {
            countryId: values.countryId,
            contractId: localStorage.getItem("currentContractId"),
            stateIds: values.state,
            cityIds: values.cityId,
            clientFocalPoint: values.clientFocalPoint,
            clientFocalPointEmail: values.clientFocalPointEmail.toLowerCase(),
            referenceDocuments: values.referenceDocuments || "",
            linkToSharedDrive: values.linkToSharedDrive,
            targetVisits: values.targetVisits,
            additionalVisits: values.additionalVisits,
          },
          clients: values.clients.map((clientId) => {
            const client = clients.find((c) => c.id === clientId);
            return { id: client.id, name: client.name };
          }),
        };

        httpService.put(
          `/api/projects`,
          requestBody,
          (response) => {
            form.resetFields();
            onSubmit();
            const message =
              response.message ||
              "This project was correctly updated to your database.";
            setMessage({
              trigger: true,
              type: "success",
              icon: ProjectIcon,
              title: "Project updated successfully!",
              text: message,
            });
            handleLeave();
            setLoading(false);
          },
          (error) => {
            console.error("There was an error updating the project!", error);
            const errorMessage =
              error?.errors?.[0]?.message ||
              error?.message ||
              "We had a problem updating this project, please try again.";
            setMessage({
              trigger: true,
              type: "danger",
              icon: ProjectIcon,
              title: "Oops! A problem has occurred!",
              text: errorMessage,
            });
            setLoading(false);
          }
        );
      })
      .catch((errorInfo) => {
        console.error("Validation Failed:", errorInfo);
      });

    setMessage({
      trigger: false,
      type: "",
      icon: null,
      title: "",
      text: "",
    });
  };

  return (
    <Modal
      visible={visible}
      closable={false}
      onCancel={handleCancel}
      footer={false}
      width={800}
      destroyOnClose
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          marginBottom: "20px",
        }}
      >
        <img
          src={cancelX}
          style={{ marginLeft: "auto", cursor: "pointer" }}
          onClick={handleCancel}
        />
      </div>
      <h2 className="modalHeader">Edit Project Round</h2>
      <Spin spinning={componentLoading}>
        <Form form={form} layout="vertical">
          <p className="modalsHeader1">Project Details</p>
          <Form.Item
            name="projectName"
            label="Project Round Name"
            rules={[
              { required: true, message: "Please enter project round name" },
            ]}
          >
            <Input placeholder="Enter project round Name" autoComplete="off" />
          </Form.Item>
          <Form.Item
            name="projectNumber"
            label="Project Round Code"
            rules={[
              { required: true, message: "Please enter project round code" },
            ]}
          >
            <Input placeholder="Enter project round code" autoComplete="off" />
          </Form.Item>
          <div className="d-flex flex-row">
            <Form.Item
              name="targetVisits"
              label="Target Visits for This Round"
              rules={[
                {
                  required: true,
                  type: "number",
                  message: "Please enter target visits for this round",
                },
              ]}
              style={{ width: "50%" }}
            >
              <InputNumber
                type="number"
                min={1}
                placeholder="1"
                autoComplete="off"
              />
            </Form.Item>
            <Form.Item name="additionalVisits" label="Additional Visits">
              <InputNumber
                type="number"
                min={0}
                placeholder="0"
                autoComplete="off"
              />
            </Form.Item>
            {/* F-03 — per-project escalation threshold. Optional: leave empty
                to use the per-task-type threshold / platform default. */}
            <Form.Item
              name="stalledThresholdDays"
              label="Stalled threshold (days)"
              tooltip="How many days without an update before a task or site visit in this project is flagged as stalled. Leave empty to use the default or the per-task-type value."
            >
              <InputNumber
                type="number"
                min={1}
                placeholder="Default"
                autoComplete="off"
              />
            </Form.Item>
          </div>
          <Divider />
          <Spin spinning={loadingCities}>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <Form.Item
                name="countryId"
                tooltip="The list of countries displayed here comes from the countries you selected when creating the contract. The country you select now will be shown in this project."
                label="Country"
                rules={[{ required: true, message: "Please select country" }]}
                style={{ width: "48%" }}
              >
                <Select
                  onChange={handleCountryChange}
                  placeholder="Select Country"
                  showSearch
                  allowClear
                  filterOption={(input, option) =>
                    option.children
                      .toLowerCase()
                      .startsWith(input.toLowerCase())
                  }
                >
                  {allCountries &&
                    allCountries.map((country) => (
                      <Option key={country.id} value={country.id}>
                        {country.stateName}
                      </Option>
                    ))}
                </Select>
              </Form.Item>
              <Form.Item
                name="state"
                tooltip="The list of states you select now will be shown in this project."
                label="Governorate/State"
                className={states.length < 1 ? "d-none" : ""}
                rules={[
                  {
                    required: true,
                    message: `${
                      cities.length < 1
                        ? "Please select governorate/state or city"
                        : "Please select governorate/state"
                    }`,
                  },
                ]}
                style={{ width: "48%" }}
              >
                <Select
                  mode="multiple"
                  placeholder="Select governorate or state"
                  showSearch
                  filterOption={(input, option) =>
                    option.children
                      .toLowerCase()
                      .startsWith(input.toLowerCase())
                  }
                  allowClear
                  onChange={handleStateChange}
                  value={form.getFieldValue("state")}
                >
                  {states.length > 0 && (
                    <Option key="__all__" value="__all__">
                      Select All
                    </Option>
                  )}
                  {states.map((state) => (
                    <Option key={state.id} value={state.id}>
                      {state.stateName}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </div>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <Form.Item
                name="cityId"
                label="City/Disctrict/Municipality:"
                tooltip="The list of cities you select now will be shown in this project."
                className={cities.length < 1 ? "d-none" : ""}
                rules={[
                  {
                    required: cities.length,
                    message: "Please select one or more cities",
                  },
                ]}
                style={{ width: "48%" }}
              >
                <Select
                  placeholder="Select one or more cities"
                  disabled={cities.length < 1}
                  showSearch
                  allowClear
                  mode="multiple"
                  filterOption={(input, option) =>
                    option.children
                      .toLowerCase()
                      .startsWith(input.toLowerCase())
                  }
                  onChange={handleCityChange}
                  value={form.getFieldValue("cityId")}
                >
                  {cities.length > 0 && (
                    <Option key="__all__" value="__all__">
                      Select All
                    </Option>
                  )}
                  {cities.map((city) => (
                    <Option key={city.id} value={city.id}>
                      {city.name}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </div>
          </Spin>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <Form.Item
              name="clients"
              label="Clients"
              rules={[{ required: true, message: "Please select a client" }]}
              style={{ width: "48%" }}
            >
              <Select
                placeholder="Select Clients"
                mode="multiple"
                showSearch
                allowClear
                filterOption={(input, option) =>
                  option.children.toLowerCase().startsWith(input.toLowerCase())
                }
              >
                {clients &&
                  clients.map((client) => (
                    <Option key={client.id} value={client.id}>
                      {client.name}
                    </Option>
                  ))}
              </Select>
            </Form.Item>
            <Form.Item
              name="clientFocalPoint"
              label="Client Focal Point"
              style={{ width: "48%" }}
              rules={[
                {
                  required: true,
                  message: "Please enter a client focal point",
                },
              ]}
            >
              <Input placeholder="example" autoComplete="off" />
            </Form.Item>
          </div>
          <Form.Item
            name="clientFocalPointEmail"
            label="Client Focal Point Email"
            rules={[
              {
                required: true,
                message: "Please enter a client focal point email",
              },
            ]}
          >
            <Input placeholder="example" autoComplete="off" />
          </Form.Item>
          <Form.Item name="projectDescription" label="Project Description">
            <TextArea placeholder="Project Description" rows={4} />
          </Form.Item>
          <Form.Item
            name="referenceDocuments"
            label="Links to Reference Documents (communications doc link, etc.)"
          >
            <TextArea placeholder="Links to Reference Documents" rows={4} />
          </Form.Item>
          <Form.Item
            name="linkToSharedDrive"
            label="Link to Shared Drive"
            tooltip="Please give a valid link ex: http://... or http://... or www..."
            rules={[
              {
                required: false,
                message: "Please enter a Link to Shared drive",
              },
              {
                pattern: new RegExp(
                  /((([A-Za-z]{3,9}:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)/
                ),
                message: "Please enter a valid URL",
              },
            ]}
          >
            <Input
              placeholder="http://www.link-shared-drive.com"
              autoComplete="off"
            />
          </Form.Item>

          <div className="buttonsModal">
            <Button
              className="inviteButtonTPM"
              key="cancel"
              onClick={handleCancel}
            >
              Cancel
            </Button>
            <Button
              className="addButtonTPM"
              key="submit"
              type="primary"
              onClick={handleOk}
              loading={loading}
              disabled={loading}
            >
              Save Changes
            </Button>
          </div>
        </Form>
      </Spin>
    </Modal>
  );
};

export default EditProject;
